import { Controller } from 'stimulus';

/**
 * Enables an element once JavaScript has loaded, preventing users from
 * interacting with turbo-stream-dependent controls before Stimulus is ready.
 *
 * Without this, clicking a turbo stream link/button before JS loads causes the
 * browser to navigate to and render the raw turbo stream HTML response.
 *
 * By default the element is enabled on connect. Set `enable` to `false` to
 * keep the element disabled (e.g. when it is legitimately disabled for
 * business logic reasons, not just because JS hasn't loaded yet).
 *
 * Supports both buttons (via `disabled` attribute) and links (via
 * `aria-disabled` attribute + `pointer-events: none` CSS).
 *
 * @example Button — enable on connect (default)
 *   <button disabled data-controller="turbo-ready">Vote</button>
 *
 * @example Button — keep disabled (legitimately disabled)
 *   <button disabled data-controller="turbo-ready" data-turbo-ready-enable-value="false">
 *     Already Voted
 *   </button>
 *
 * @example Link — enable on connect
 *   <a href="..." aria-disabled="true" data-controller="turbo-ready"
 *      data-turbo="true" data-turbo-stream="true">Submit Entry</a>
 */
export default class extends Controller {
  static values = { enable: { type: Boolean, default: true } };

  connect() {
    if (!this.enableValue) {
      return;
    }

    if (this.element.tagName === 'A') {
      this.element.removeAttribute('aria-disabled');
    } else {
      this.element.disabled = false;
    }
  }
}
